'use client';

import { Suspense } from 'react';
import styles from './footer-script.module.scss';

export default function FooterScript({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <Suspense>
      <div id="everything" className="everything">
        <div id="content">
          <div id="body" className="body" />
          {children}
        </div>
        <div id="footer" className={styles['footer']} />
      </div>
    </Suspense>
  );
}
